import { Expose, Type } from 'class-transformer';
import { IsNotEmpty, IsString, IsUUID } from 'class-validator';
import { DeviceStatus } from '../../enums/auth';
import { UserAgentDto } from './user-agent.dto';

export class DeviceResponseDto {
    @Expose()
    @IsUUID()
    @IsNotEmpty()
    id: string;

    @Expose()
    @Type(() => UserAgentDto)
    userAgent: UserAgentDto;

    @Expose()
    @IsString()
    browser: string;

    @Expose()
    @IsString()
    os: string;

    @Expose()
    @IsString()
    ipAddress: string;

    @Expose()
    @IsString()
    status: DeviceStatus;

    @Expose()
    @IsString()
    lastLoginAt: Date | null;

    @Expose()
    @IsString()
    createdAt: Date;
}
